// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__c8Uyw","loading":"skeleton_loading__TTH2A"};